import React from 'react';
import { CTAButton } from './CTAButton';
import { SectionHeading } from './SectionHeading';
import { painPoints } from '../data/audit';
export function PainPoints() {
  return <section className="bg-cream-100 px-4 py-14 sm:px-6 sm:py-20" data-id="element-250" data-mp="26ypit95htotx">
      <div className="mx-auto w-full max-w-5xl" data-id="element-251" data-mp="26y62fwvhr8i0">
        <SectionHeading eyebrow="Be honest" title="Does this sound familiar?" data-id="element-252" data-mp="2bwr13rv3hk4c" />

        <div className="mt-10 grid gap-4 sm:grid-cols-2" data-id="element-253" data-mp="1xwomqflzx8tu">
          {painPoints.map(p => <article key={p.title} className="flex flex-col rounded-2xl bg-white p-5 ring-1 ring-navy-900/8 sm:p-6" data-id="element-254" data-mp="21zl8ugaqvn2j">
              <span className="text-2xl" aria-hidden="true" data-id="element-255" data-mp="1o1wpxe08mq04">
                {p.emoji}
              </span>
              <h3 className="mt-3 font-display text-[17px] font-bold leading-snug text-navy-900 sm:text-lg" data-id="element-256" data-mp="3idl5nieamwlk">
                {p.title}
              </h3>
              <p className="mt-2 text-[14px] leading-relaxed text-navy-700/80 sm:text-[15px]" data-id="element-257" data-mp="3nc5wir7no3xc">
                {p.text}
              </p>
            </article>)}
        </div>

        <div className="mx-auto mt-10 max-w-3xl rounded-3xl bg-navy-900 p-6 text-center sm:p-8" data-id="element-258" data-mp="1u0iyn4gcruv1">
          <p className="text-[11px] font-extrabold uppercase tracking-[0.16em] text-gold-400" data-id="element-259" data-mp="27rxg36um3nzz">
            If you said yes to even one of these…
          </p>
          <p className="mt-3 text-base leading-relaxed text-cream-100/85 sm:text-lg" data-id="element-260" data-mp="1g1t15npmft65">
            You’re not necessarily missing more information. You may simply need a{' '}
            <strong className="font-bold text-cream-50" data-id="element-261" data-mp="1b4st5797ogce">
              repeatable system for reviewing the information you already have
            </strong>
            .
          </p>
        </div>

        <div className="mt-10" data-id="element-262" data-mp="1k5ilg0z9jold">
          <CTAButton label="Get the Complex Rehab Case Audit™" subLabel="$27 one-time · Instant digital access" data-id="element-263" data-mp="30he65xurest1" />
        </div>
      </div>
    </section>;
}